export const USUARIO_LOADING = 'USUARIO_LOADING';
export const USUARIO_SET = 'USUARIO_SET';
export const USUARIO_PERMISSAO = 'USUARIO_PERMISSAO';
export const LISTAR_USUARIO = 'LISTAR_USUARIO';